module.exports = __webpack_public_path__ + "static/media/17.8d22b5fb.wav";